let language = {
    "STORES-DELETE-ALERT-INFO-TITLE": "Delete Item",
    "STORES-DELETE-ALERT-INFO-CONTENT": "No selected item was selected",
    "STORES-DELETE-ALERT-WARNING-TITLE": "Delete Store",
    "STORES-DELETE-ALERT-WARNING-CONTENT": "Are you sure to delete the store ?",
    "STORES-DELETE-ALERT-INFO-TITLE-RESULT": "Delete result",
    "STORES-DELETE-ALERT-INFO-CONTENT-RESULT": ".\n Delete failed:",
    "STORES-DELETE-ALERT-INFO-CONTENT-RESULT-SUCCESS": "Deleted Successfully",
    "STORES-REFRESH-SUCCESS": "Refresh Successfully!",
    "STORES-REFRESH-FAIL": "Refresh Failed!",
    "STORES-STATUS-ACTIVATE-TITLE": "Activate Store",
    "STORES-STATUS-ACTIVATE-CONTENT": "Are you sure to Activate the store ?",
    "STORES-ALERT-SUCCESS-TITLE": "Success",
    "STORES-ALERT-ACTIVATE-SUCCESS-CONTENT": "Activate successfully ! ",
    "STORES-ALERT-ENABLE-SUCCESS-CONTENT": "Enable successfully ! ",
    "STORES-ALERT-FAIL-TITLE": "Failed",
    "STORES-ALERT-ACTIVATE-FAIL-CONTENT": "Enable failed ! ",
    "STORES-ALERT-SAVE-FAIL-CONTENT": "Save failed ! ",
    "STORES-ALERT-REMOVE-FAIL-CONTENT": "Remove failed ! ",
    "STORES-ALERT-AUTHORIZATION-FAIL-CONTENT": "Get External Authorization failed ! ",
    "STORES-ALERT-URL-EXISTS-FAIL-CONTENT": "This url already exists ! ",
    "STORES-ALERT-INCORRECT-CONNECTION-FAIL-CONTENT": "Incorrect connection information ! ",
    "STORES-ALERT-CONNECT-FAIL-CONTENT": "Connect failed ! ",
    "STORES-STATUS-CLOSE-TITLE": "Are you sure to inactive the store ?",
    "STORES-STATUS-CLOSE-CONTENT": "When inactive the store, your products and orders will lose the connection with your online e-shop. Do you want to continue inactive this store?",
    "STORES-STATUS-CLOSE-BTN": "Inactive",
    "STORES-STATUS-CLOSE-SUCCESS-CONTENT": "Inactive successfully ! ",
    "STORES-STATUS-CLOSE-FAIL-CONTENT": "Inactive failed ! ",
    "STORES-STATUS-DRAFT-QUESTION-TITLE": "Draft Store",
    "STORES-STATUS-DRAFT-QUESTION-CONTENT": "Are you sure to draft the store ?",
    "STORES-STATUS-DRAFT-FAIL-CONTENT": "Draft failed ! ",
    "STORES-STATUS-DRAFT-SUCCESS-CONTENT": "Draft successfully ! ",
    "STORES-ALERT-BILLING-ADDRESS-CONTENT": "The billing address is missing a postal code, please fill it in.",
    "STORES-ALERT-REFUND-ADDRESS-CONTENT": "The refund address is missing a postal code, please fill it in.",
    "STORES-ALERT-REMOVE-STORE-TITLE": "Remove Store",
    "STORES-ALERT-REMOVE-STORE-CONTENT": "This action will delete all store related content !",
    "STORES-ALERT-ENABLE-STORE-TITLE": "Enable Store",
    "STORES-ALERT-ENABLE-STORE-CONTENT": "Are you sure to enable the store ?",
    "STORES-CREATE-STORE-ISSUE-TITLE":"Create store issue",
    "STORES-CREATE-STORE-ISSUE-CONTENT":"There was an issue creating the Manual Order Hub. Please try again. If the problem persists, contact us at {{supportmail}}.",
};

export { language }